import { Title, Description } from '@radix-ui/react-dialog';

import { OverlayCommonProps } from './types';

import { StringNodeGuard } from '../helpers';
import { cn } from 'styles';

type HeaderProps = Pick<OverlayCommonProps, 'title' | 'description'> & {
  /**
   * Switches the proper components depending of the parent overlay type
   *
   * Example: popover can't use DialogTitle inside of it...
   */
  isDialog?: boolean;

  /**
   * Controls the text size of the default text references
   *
   * Reduced basically means 1 less for each (title and description)
   *
   * Example:
   * - title: lg => base
   * - description sm -> xs
   */
  sizing?: 'normal' | 'reduced';
};

export function OverlayHeader({ description, title, isDialog = true, sizing }: HeaderProps) {
  const ActualTitle = isDialog ? Title : 'h2';

  if (!description && !title) return <ActualTitle className="hidden">.</ActualTitle>;

  const ActualDescription = isDialog ? Description : 'p';

  const isReduced = sizing === 'reduced';

  return (
    <div className={cn('flex flex-col', isReduced ? 'gap-0.5' : 'gap-1.5')}>
      <StringNodeGuard node={title}>
        <ActualTitle
          className={cn(
            'font-semibold leading-none tracking-tight',
            isReduced ? 'text-base' : 'text-lg',
          )}
        >
          {title}
        </ActualTitle>
      </StringNodeGuard>

      {/* Prevent warning */}
      <ActualTitle className="hidden">.</ActualTitle>

      <StringNodeGuard node={description}>
        <ActualDescription
          className={cn('text-sm text-muted-foreground', isReduced ? 'text-xs' : 'text-sm')}
        >
          {description}
        </ActualDescription>
      </StringNodeGuard>
    </div>
  );
}
